import actions from "actions";
import Pagination from "components/Pagination/TablePagination";
import MoreVertIcon from "material-ui-icons/MoreVert";
import IconButton from "material-ui/IconButton";
import Menu, { MenuItem } from "material-ui/Menu";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import InputField from "components/InputField/InputField.jsx";

const labels = ["Date", "Title", "Created By", "View File", "Actions"];

const { getGroupMaterials, clearStudyGroupMaterial, deleteStudyGroupMaterial } =
  actions;

class StudyGroupSuperhostMaterials extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      per_page: 10,
      search: "",
    };
  }

  componentDidMount() {
    this.loadGroupMaterials();
  }

  componentWillUnmount() {
    this.props.clearStudyGroupMaterial();
  }

  loadGroupMaterials = () =>
    this.props.getStudyGroupMaterials({
      page: this.state.page,
      group_id: this.props.params.id,
      per_page: this.state.per_page,
      search: this.state.search,
    });

  handleSelectFile = (id) => {
    this.state.selected.includes(id)
      ? this.setState((state) => ({
          selected: state.selected.filter((selected) => selected !== id),
        }))
      : this.setState((state) => ({ selected: [...state.selected, id] }));
  };

  handleLoadMore = () =>
    this.setState(
      (state) => ({ page: state.page + 1 }),
      () => this.loadGroupMaterials()
    );

  onChangePage = (page) =>
    this.setState({ page }, () => this.loadGroupMaterials());

  handleQueryChange = (search, timeout = 500) => {
    this.setState({ search }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => this.loadGroupMaterials(), timeout);
    });
  };

  render() {
    const { materials, params, currentUser } = this.props;

    const { page, search } = this.state;

    const groupId = params.id;

    const isActionsDisabled = !currentUser.host_group_ids.includes(+groupId);

    return (
      <div className="group-materials-container">
        <div className="group-materials-header">
          <div
            style={{
              display: "flex",
              gap: 16,
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <div className="container_admin_user">
              <div className="search_admin">
                <input id="search" type="submit" className="validate" />
                <label htmlFor="search">
                  <i className="material-icons icon_search">search</i>
                </label>
                <input
                  type="search"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => this.handleQueryChange(e.target.value)}
                />
                <i
                  className="material-icons icon_close"
                  onClick={() => this.handleQueryChange("")}
                >
                  close
                </i>
              </div>
            </div>
          </div>
          {!isActionsDisabled && (
            <Link to={`/groups/${groupId}/resources/new`}>
              <button className="button_link">Add new resources</button>
            </Link>
          )}
        </div>
        <div style={{ width: "100%", overflowX: "auto" }}>
          <table>
            <thead>
              <tr>
                {labels.map((label, idx) => (
                  <th key={idx}>{label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {materials.data.map((item, idx) => (
                <StudyGroupSuperhostMaterialsItem
                  key={idx}
                  {...item}
                  isActionsDisabled={isActionsDisabled}
                  handleDelete={() =>
                    this.props.deleteStudyGroupMaterial(item.id)
                  }
                  groupId={groupId}
                />
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          onChangePage={this.onChangePage}
          page={page}
          total_pages={materials.totalPages}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  materials: state.studygroups.materials,
  currentUser: state.users.user,
});

const mapDispatchToProps = (dispatch) => ({
  getStudyGroupMaterials: (payload) => dispatch(getGroupMaterials(payload)),
  clearStudyGroupMaterial: (payload) =>
    dispatch(clearStudyGroupMaterial(payload)),
  deleteStudyGroupMaterial: (payload) =>
    dispatch(deleteStudyGroupMaterial(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostMaterials);

class StudyGroupSuperhostMaterialsItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      title,
      file_url,
      created_at,
      user: { first_name, last_name },
      id,
      handleDelete,
      isActionsDisabled,
      groupId,
    } = this.props;

    const { anchorEl } = this.state;

    return (
      <tr>
        <td>{moment(created_at).format("DD/MM/yyyy")}</td>
        <td>{title}</td>
        <td>
          {first_name} {last_name}
        </td>
        <td>
          <a href={file_url} target="_blank">
            <button className="button_link">View File</button>
          </a>
        </td>
        <td>
          {isActionsDisabled ? null : (
            <div>
              <IconButton
                className="table_more"
                aria-label="More"
                aria-owns={anchorEl ? "long-menu" : null}
                aria-haspopup="true"
                onClick={this.handleClick}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
                PaperProps={{
                  style: {
                    width: 200,
                  },
                }}
              >
                <Link to={`/groups/${groupId}/resources/${id}/edit`}>
                  <MenuItem>Edit</MenuItem>
                </Link>
                <MenuItem onClick={handleDelete}>Delete</MenuItem>
              </Menu>
            </div>
          )}
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostMaterials.jsx